module.exports = "/wwwroot/img/ajax-loader2.gif?ver=56163127";